import React, {useCallback} from "react";
import { useRegionSelectGroupedQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import clone from 'clone';
import { GraphQlSelectId } from "./GraphQlSelectId";


export const RegionSelectGrouped = (props) => {
    const query = useRegionSelectGroupedQueryQuery();
    const filterOptions = useCallback((options) => {

        const newOptions = [];
        /*if(props.allowBlank) {
            newOptions.push({icon:'cross',id:0,label:'None',region:{id:0,name:''},regionType:{id:0,name:''},src:{}});
        }*/
        options.forEach(regionType => {
            regionType?.regions?.forEach(region => {
                if(props.areaOnly) {
                    if(!region.is_area_booking) return;
                }
                if(props.panelOnly) {
                    if(!region.is_panel_booking) return;
                }
                const src = clone(region);
                src.regionType = Object.assign({},regionType);
                delete src.regionType.regions;
//                newOptions.push({id:region.id,region:region,regionType:regionType,src:src});
                newOptions.push(src);
            })
        });
        console.log('RSG are',newOptions);
        return [...newOptions];
    }, []);
    //const getValue = (k)=>(k.src);
    /*const onChange = props.isCompositeChange?((evt)=> {
            props.onChange({target:{name:evt.target.name,value:evt.target.value}});
        }
    ):props.onChange;*/

    // modifying the value itself causes problems 
    /*if(props.value && !props.value.label) {
        if(props.value.regionType) {
            props.value.label = props.value.regionType.name+' / '+props.value.name;
        }
    }*/
    return (
        props.valueIsId ? <GraphQlSelectId {...props} queryResult={query} labelField="label" renderOptionString={(option) => {
            if (!option || (Array.isArray(option) && !option.length)) {
                return props.blankLabel ?? 'None';
            }
            return option?.regionType?.name + ' / ' + option?.name;
        }} filterOptions={filterOptions} /> :
            <GraphQlSelect {...props} queryResult={query} labelField="label" renderOptionString={(option) => {
                if (!option || (Array.isArray(option) && !option.length)) {
                    return props.blankLabel ?? 'None';
                }
                return option?.regionType?.name + ' / ' + option?.name;
            }} filterOptions={filterOptions} />);
}


